var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57905 32.4999C9.57905 32.4999 -6.33913 26.7877 3.59938 9.0332C3.59938 9.0332 2.66074 15.2007 4.3006 18.9239C5.94045 22.6472 8.19318 25.8284 9.57905 32.4999Z",
    fill: "url(#paint0_linear_11_7660)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 32.4998C14.3085 31.8105 16.0298 30.7368 17.4757 29.3475C19.0777 27.8177 20.2926 25.9318 21.0209 23.8443C21.8656 21.1332 21.8823 18.2333 21.0689 15.5126C20.5434 13.4433 19.6399 11.4879 18.4034 9.74414C18.6782 12.6003 18.4013 15.4825 17.5877 18.235C16.8627 20.6231 16.0523 21.7216 14.8262 24.72C13.7996 27.2389 12.9951 29.842 12.4219 32.4998Z",
    fill: "url(#paint1_linear_11_7660)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.419 26.8112C11.9836 26.8112 12.344 25.6132 13.3658 22.9979C14.0219 21.3239 14.2854 20.896 14.5704 20.0831C14.9025 19.1972 15.1721 18.2894 15.3771 17.3662C16.201 13.8183 16.1808 10.1281 15.318 6.58943C14.8562 5.07821 14.1614 3.64745 13.2582 2.34826C12.4246 1.15025 12.0052 0.551246 11.3975 0.503111C9.78408 0.374753 8.06852 4.24689 7.35326 6.73918C6.45409 10.3991 6.53754 14.2297 7.59526 17.8475C7.96096 19.0081 8.49875 20.3933 8.49875 20.3933C8.89672 21.4094 9.12797 21.7464 9.57434 22.9979C10.5262 25.4581 10.8274 26.8005 11.419 26.8112Z",
    fill: "url(#paint2_linear_11_7660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_7660",
    x1: 0.441143,
    y1: 14.0029,
    x2: 11.4861,
    y2: 31.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_7660",
    x1: 21.9432,
    y1: 13.6553,
    x2: 10.9902,
    y2: 31.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_7660",
    x1: 11.3437,
    y1: 3.78694,
    x2: 11.3437,
    y2: 30.0041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D776"
  })))));
}

export default __webpack_public_path__ + "media/09bcbe2e.svg";
export { SvgFinance as ReactComponent };